module.exports = __webpack_public_path__ + "img/order-number.6c6a4a30.svg";